import { format } from 'date-fns';

import { getLocalDateTime } from '@/utils/date';

import type { SaversTrailerMovement } from '../../types';
export const normalizeUpdateTrailerRequest = (
  // biome-ignore lint/suspicious/noExplicitAny: TODO: Add types here
  data: any,
  trailerMovementData: SaversTrailerMovement,
  shipmentType: string,
) => {
  return {
    book: Number(data.trailerShippings[0][`${shipmentType}bookweight`]),
    dateShipped: format(getLocalDateTime(), 'yyyy-MM-ddTHH:mm:ss.SSS'),
    furn: Number(data.trailerShippings[0][`${shipmentType}furn`]),
    misc: Number(data.trailerShippings[0][`${shipmentType}miscweight`]),
    oli: Number(data.trailerShippings[0][`${shipmentType}oli`]),
    shipmentNumber: trailerMovementData.shipmentNo,
    soft: Number(data.trailerShippings[0][`${shipmentType}softweight`]),
    trailerId: trailerMovementData.trailerShippings[0].trailerID,
    vendorID: trailerMovementData?.vendorID?.trim(),
  };
};
